const projectDetails = [
    {name: "FeedWise", 
    tech:"Java | Hibernate | MySQL | ReactTS | Security",
    story:"Smart, real-time platform to optimize food donation and distribution. Centralizes supply data to improve logistics and enable needs-based delivery to distribution centers.",
    git:"https://github.com/joyliao07/spring_foodbank",
    deploy:"",
    color: "(72, 187, 219)",
    colorHover: "(240, 250, 252) "},

    {name: "AI Bot", 
    tech:"GO| PostgreSQL | Docker | VueJS", 
    story: "Microservice-based platform integrating OpenAI APIs to generate text and images, with controlled user access and usage quotas. Supports delivery of AI-generated content via email.",
    git:"https://github.com/joyliao07/aibot_vue",
    deploy:"",
    color: "(224, 241, 245)",
    colorHover: "(193, 227, 235)"},

];

export default projectDetails;